import { FC, createContext, useContext, useEffect, useState } from "react";
import useFetch from "src/hooks/useFetch";
import { APIEndpoints } from "src/types/apiTypes";
import { CaseContextProps, CaseDraftListingAPIRes } from "./types";
import { AuthContext } from "../authContext";
import { AddCaseProps } from "src/pages/addCase/types";


export const CaseContext = createContext<CaseContextProps>({
  draftCaseId: 0,
  updateDraftCaseId: (draftId: number) => {},
  isCaseDraftSaved: false,
  updateCaseDraftStatus: (isCaseDraftSaved: boolean) => {},
  caseDraftListing: undefined,
  getCaseDraftListing: () => {},
  currentCaseDraft: null,
})


const CaseProvider: FC<{ children: JSX.Element }> = ({ children }): JSX.Element => {
  const [draftCaseId, updateDraftCaseId] = useState<number>(0);
  const [isCaseDraftSaved, updateCaseDraftStatus] = useState<boolean>(false);
  const [currentCaseDraft, updateCurrentCaseDraft] = useState<Partial<AddCaseProps> | null>(null)

  const { userData, updateUserData } = useContext(AuthContext)



  const { data: caseDraftListing, mutate: getCaseDraftListing } =
    useFetch<CaseDraftListingAPIRes>(APIEndpoints.GET_CASE_DRAFTS)

  useEffect(() => {
    if (caseDraftListing) {
      const { status, result } = caseDraftListing;
      if (status === 200) {
        if (userData) updateUserData({ ...userData, draft_count: result.length })
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [caseDraftListing])


  useEffect(() => {
    if (draftCaseId && caseDraftListing && caseDraftListing.result) {
      const currentDraft = caseDraftListing.result.find((draft) => draft.id === draftCaseId)
      if (currentDraft) {
        updateCurrentCaseDraft(JSON.parse(currentDraft.draft_json))
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [draftCaseId])




  return (
    <CaseContext.Provider
      value={{ 
        draftCaseId, updateDraftCaseId,
        isCaseDraftSaved, updateCaseDraftStatus,
        caseDraftListing, getCaseDraftListing,
        currentCaseDraft
      }}
    >
      {children}
    </CaseContext.Provider>
  )
}

export default CaseProvider
